import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {VgCoreModule} from 'videogular2/core';
import {VgControlsModule} from 'videogular2/controls';
import {VgOverlayPlayModule} from 'videogular2/overlay-play';
import {VgBufferingModule} from 'videogular2/buffering';
import {VideoPlayer4Component} from './video-player-4.component';
import {ModalVideoComponent} from '../../components/modals/modal-video/modal-video.component';
import {TranslatePipe4} from '../../pipes/translate/translate4.pipe';
import {ModalVideoRoundComponent} from '../../components/modals/modal-video-round/modal-video-round.component';

@NgModule({
    declarations: [VideoPlayer4Component, TranslatePipe4],
    imports: [
        CommonModule,
        FormsModule,
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule
    ],
    exports: [VideoPlayer4Component],
    entryComponents: [
        ModalVideoComponent,
        ModalVideoRoundComponent
    ]
})
export class VideoPlayer4ComponentModule {
}
